module.exports = __webpack_public_path__ + "img/picture_slt03.133b1f95.png";